import { render, staticRenderFns } from "./OResetPassEmail.vue?vue&type=template&id=1fd02a09&scoped=true&"
import script from "./OResetPassEmail.vue?vue&type=script&lang=ts&"
export * from "./OResetPassEmail.vue?vue&type=script&lang=ts&"
import style0 from "./OResetPassEmail.vue?vue&type=style&index=0&id=1fd02a09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd02a09",
  null
  
)

export default component.exports